import { navigatePage, navigationEntry } from '@/runtime/page-navigation'
import { previewNodes } from '@/runtime/preview-snapshot'
import { templatePreviewNodes } from '@/runtime/template-preview'
import { sharedViewNodes } from '@/runtime/shared-view'
import { captureFleetListViews } from '@/runtime/fleet-list-view'

export default {
  data () {
    return { pageNavigation: navigationEntry(''), navigationError: '', navigationBusy: false }
  },
  computed: {
    navigationContext () { return this.pageNavigation.context },
    canNavigateBack () { return this.pageNavigation.trail.length > 0 },
    currentPageName () {
      const page = this.pageProject.pages.find(page => page.id === this.activePageId)
      return page ? page.name : ''
    }
  },
  methods: {
    resetPageNavigation () {
      this.pageNavigation = navigationEntry(this.activePageId)
      this.navigationError = ''
      this.navigationBusy = false
    },
    runPageNavigation (node) {
      if ((this.$route.name !== 'view' && !this.isTemplatePreview && !this.isSharedView) || this.navigationBusy || !this.projectRecord) return
      const container = this.$refs.container
      const surface = container.$el
      let next
      try {
        if (node.navigation && node.navigation.type === 'product' && (!node.component || !['productList', 'deviceList'].includes(node.component.prop))) {
          throw new Error('按产品跳转仅适用于产品列表或设备列表组件')
        }
        const origin = { nodeId: node.index, x: surface.scrollLeft, y: surface.scrollTop, lists: captureFleetListViews(surface) }
        if (node.component && ['productList', 'deviceList'].includes(node.component.prop) && node.data && node.data.row) {
          origin.rowId = node.data.row.id
        }
        const replace = node.component && node.component.name === 'navigation' && node.component.prop === 'navigation' && node.option && node.option.mode === 'pages'
        const listKind = node.component && node.component.prop === 'deviceList' ? 'device' : 'product'
        next = navigatePage(this.pageProject, this.pageNavigation, node.navigation, node.data, origin, { replace, listKind })
      } catch (error) {
        this.navigationError = error.message
        return
      }
      if (next === this.pageNavigation) return
      const target = this.pageProject.pages.find(page => page.id === next.pageId)
      this.navigationBusy = true
      this.navigationError = ''
      container.clearSubscriptions()
      this.pageNavigation = next
      this.activePageId = target.id
      this.config = target.config
      // 每次切页重新净化；普通项目预览保留平台设备数据，仍不恢复任意接口或脚本。
      this.nav = this.isSharedView ? sharedViewNodes(target.nodes, this.isSharedDataView, this.shareControlAvailable === true) : this.isTemplatePreview ? target.nodes : (this.isPreview && this.obj.templatePreview === true) ? templatePreviewNodes(target.nodes, { runtimeSource: true }) : this.isPreview ? previewNodes(target.nodes, { liveDeviceData: this.liveProjectPreview === true }) : target.nodes
      this.handleInitActive()
      this.$nextTick(() => {
        if (this._isDestroyed || this.pageNavigation !== next) return
        const restore = next.restore || {}
        surface.scrollLeft = restore.x || 0
        surface.scrollTop = restore.y || 0
        const focusTarget = Array.from(surface.querySelectorAll('[data-page-action]')).find(el => el.getAttribute('data-page-action') === restore.nodeId)
        const canvas = container.$refs.container
        if (focusTarget) focusTarget.focus({ preventScroll: true })
        else if (canvas) canvas.focus({ preventScroll: true })
        this.navigationBusy = false
      })
    }
  }
}
